import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { change } from 'redux-form';
import { connect } from 'react-redux';

class MultiFileInputComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.any
    }).isRequired,
    meta: PropTypes.shape({
      form: PropTypes.string
    }).isRequired,
    accept: PropTypes.string,
    required: PropTypes.bool,
    className: PropTypes.string
  };

  static defaultProps = {
    accept: '',
    required: false,
    className: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      file: undefined,
      beneficiaryFilesList: undefined
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const fileStore1 = e.target.files;
    const filenames = [];
    Array.from(fileStore1).forEach((file) => {
      if (file != null) {
        filenames.push(file.name);
      }
    });
    this.setState(
      { file: fileStore1,
        beneficiaryFilesList: filenames.length > 0
          ? filenames.join(', ')
          : undefined }
    );
    this.changeFileValue(fileStore1);
  }

  changeFileValue(value) {
    const {
      dispatch,
      input: { name },
      meta: { form }
    } = this.props;
    dispatch(change(
      form,
      name,
      value
    ));
  }

  removeFile() {
    this.setState(
      { file: undefined,
        beneficiaryFilesList: undefined }
    );
    const { id } = this.props;
    const inputEl = document.getElementById(id);
    if (inputEl) {
      inputEl.value = '';
    }
    this.changeFileValue(null);
  }

  render() {
    const {
      id,
      input: {
        name
      },
      accept,
      required,
      className
    } = this.props;
    const {
      file,
      beneficiaryFilesList
    } = this.state;
    return (
      <div className="file-input-custom input-group">
        <span className="input-group-addon">Choose file</span>
        <input
          type="text"
          className={ className }
          placeholder={ beneficiaryFilesList !== undefined ? beneficiaryFilesList : 'No file selected' }
        />
        { file && <span
          title="Remove file"
          className="btn btn-sm input-group-btn"
        >
          <span
            role="button"
            onClick={ () => this.removeFile() }
            tabIndex={ 0 }
            className="icon icon-cross"
            aria-hidden="true"
          />
        </span> }
        <input
          id={ id }
          name={ name }
          type="file"
          onChange={ e => this.onChange(e) }
          accept={ accept }
          required={ required }
          multiple
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

// eslint-disable-next-line import/prefer-default-export
export const MultiFileInput = connect(
  null,
  mapDispatchToProps
)(MultiFileInputComponent);
